"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("./context");
const utils_1 = require("../../utils");
const react_use_1 = require("react-use");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const index_1 = require("./index");
const query_string_1 = tslib_1.__importDefault(require("query-string"));
const osmosysCanvasReducer_1 = require("./osmosysCanvasReducer");
function OsmosysCanvasPageInner({ children, onQueryChange, defaultPrefs, onRouteChange, }) {
    /* Reducer */
    const [canvasStateData, dispatchCanvasAction] = osmosysCanvasReducer_1.useOsmosysCanvasReducer({
        canvasQueries: {},
        meta: {},
        prefs: Object.assign({}, defaultPrefs),
        ready: false,
        state: {},
    });
    /* History helpers */
    // Router
    const router = use_react_router_1.default();
    // Query String
    const queryParams = react_1.useMemo(() => {
        return query_string_1.default.parse(location.search);
    }, [location.search]);
    /* State */
    const canvasState = Object.assign(Object.assign({}, canvasStateData), { pathParams: router.match.params, queryParams,
        router });
    /*
      Pre-Ready - "Ready" state is defined by the consumer of this component,
      but "Pre-Ready" indicates that a "Ready" state can even be assigned
    */
    const isPreReady = react_1.useMemo(() => {
        if (!canvasStateData.canvasQueries) {
            return false;
        }
        return !Object.values(canvasStateData.canvasQueries).find(q => {
            return !q || !q.result || !q.result.data;
        });
    }, [canvasStateData.canvasQueries]);
    /* Query change */
    react_use_1.useDeepCompareEffect(() => {
        if (onQueryChange) {
            const { meta, state, prefs, ready } = onQueryChange(canvasState, isPreReady);
            dispatchCanvasAction({
                data: { meta, prefs, ready, state },
                type: 'update',
            });
        }
    }, [dispatchCanvasAction, canvasStateData.canvasQueries, onQueryChange]);
    /* Route change */
    react_1.useEffect(() => {
        if (onRouteChange) {
            const newData = onRouteChange(canvasState);
            dispatchCanvasAction({
                data: Object.assign({}, newData),
                type: 'update',
            });
        }
    }, [
        dispatchCanvasAction,
        onRouteChange,
        router && router.match && router.match.params,
        router && router.location && router.location.search,
        router && router.history && router.location.pathname,
        router && router.history && router.location.hash,
    ]);
    return (react_1.default.createElement(context_1.OsmosysCanvasPageContext.Provider, { value: canvasState },
        react_1.default.createElement(context_1.OsmosysCanvasPageUpdateContext.Provider, { value: {
                dispatchCanvasAction,
            } },
            react_1.default.createElement(utils_1.OsmosysDiv, { osysName: "OsmosysCanvasPage", className: ['flex-full-col', 'overflow-hidden'] }, children))));
}
exports.OsmosysCanvasPageInner = OsmosysCanvasPageInner;
OsmosysCanvasPageInner.displayName = 'OsmosysCanvasPageInner';
exports.default = index_1.OsmosysCanvasPage;
//# sourceMappingURL=Inner.js.map